export default (images) => ({
    currentPhoto: 0,
    photos: images,
    init() {
        this.changePhoto();
    },
    nextPhoto() {
        if (this.hasNext()) {
            this.currentPhoto++;
            this.changePhoto();
        }
    },
    previousPhoto() {
        if (this.hasPrevious()) {
            this.currentPhoto--;
            this.changePhoto();
        }
    },
    changePhoto() {
        this.$refs.mainImage.src = process.env.MIX_APP_URL + '/' + this.photos[this.currentPhoto];
    },
    pickPhoto(index) {
        this.currentPhoto = index;
        this.changePhoto();
    },
    hasPrevious() {
        return this.currentPhoto > 0;
    },
    hasNext() {
        return this.photos.length > (this.currentPhoto + 1);
    },
})
